// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.panel-content[data-v-d32d57f8] {\n  padding-top: 26px;\n}\n.v-expansion-panel-header--active[data-v-d32d57f8] {\n  background-color: #00747b;\n  color: #fff !important;\n  font-weight: 500;\n}\n.v-expansion-panel-header--active[data-v-d32d57f8] .mdi-chevron-down {\n  color: #fff !important;\n}\n", ""]);
// Exports
module.exports = exports;
